import { useState, useEffect } from 'react';
import { IAccountBillTo } from '../models/account';
import {
    getServiceOptions,
    getShippingOptions,
} from '../api/service-request-api';
import { IServiceRequestOptions } from '../models/service-request';
import { IConstants, ISession } from '../models/pro-sites';
import { IAccount } from '../models/company-account';

export const useBillToShipTo = (
    billToAccounts: IAccountBillTo[],
    billToAccountNumberSelected: string
) => {
    const [billToOptions, setBillToOptions] =
        useState<IServiceRequestOptions[]>();
    const [shipToOptions, setShipToOptions] =
        useState<IServiceRequestOptions[]>();

    useEffect(() => {
        if (billToAccounts.length > 0) {
            const billToCurrent = billToAccounts.find(
                (billToAccount) =>
                    billToAccount.accountNumber === billToAccountNumberSelected
            );
            if (billToCurrent) {
                setBillToOptions(
                    billToAccounts.map(
                        (billToAccount) =>
                            ({
                                text:
                                    billToAccount.fullAccountNumber +
                                    ': ' +
                                    billToAccount.partyName +
                                    ' - ' +
                                    billToAccount.customerCategory,
                                value: billToAccount.fullAccountNumber,
                            } as IServiceRequestOptions)
                    )
                );
                setShipToOptions([
                    ...billToCurrent.shipToAccounts.map(
                        (shipToAccount) =>
                            ({
                                text:
                                    shipToAccount.fullAccountNumber +
                                    ': ' +
                                    shipToAccount.partyName +
                                    ', ' +
                                    shipToAccount.street1,
                                value: shipToAccount.fullAccountNumber,
                            } as IServiceRequestOptions)
                    ),
                    {
                        text: 'Other ...',
                        value: '-1',
                    },
                ]);
            }
        }
    }, [billToAccounts.length, billToAccountNumberSelected]);

    return [billToOptions, shipToOptions];
};

export const useCurrentBillTo = (
    billToAccounts: IAccountBillTo[],
    billToAccountNumberSelected: string
) => {
    const [currentBillTo, setCurrentBillTo] = useState<IAccountBillTo>();

    useEffect(() => {
        if (billToAccounts && billToAccountNumberSelected)
            setCurrentBillTo(
                billToAccounts.find(
                    (billToAccount) =>
                        billToAccount.accountNumber ===
                        billToAccountNumberSelected
                )
            );
    }, [billToAccountNumberSelected]);

    return currentBillTo;
};

export const useCurrentShipTo = (
    shipToAccounts: IAccount[] | undefined,
    shipToFullAccountNumberSelected: string
) => {
    const [currentShipTo, setCurrentShipTo] = useState<IAccount>();

    useEffect(() => {
        if (shipToAccounts && shipToFullAccountNumberSelected)
            setCurrentShipTo(
                shipToAccounts.find(
                    (shipToAccount) =>
                        shipToAccount.fullAccountNumber ===
                        shipToFullAccountNumberSelected
                )
            );
    }, [shipToFullAccountNumberSelected]);

    return currentShipTo;
};

export const useServiceOptions = () => {
    const [serviceOptions, setServiceOptions] =
        useState<IServiceRequestOptions[]>();

    useEffect(() => {
        (async () => {
            const { data } = await getServiceOptions();
            if (data)
                setServiceOptions(
                    data.Body.map((serviceOption) => {
                        return { text: serviceOption, value: serviceOption };
                    })
                );
        })();
    }, []);

    return serviceOptions;
};
export const useShippingOptions = () => {
    const [shippingOptions, setShippingOptions] =
        useState<IServiceRequestOptions[]>();

    useEffect(() => {
        (async () => {
            const { data } = await getShippingOptions();
            if (data)
                setShippingOptions(
                    data.Body.map((shippingOption) => {
                        return { text: shippingOption, value: shippingOption };
                    })
                );
        })();
    }, []);

    return shippingOptions;
};

export const useCountry = (constants: IConstants, session: ISession | null) => {
    const [country, setCountry] = useState<string>();

    useEffect(() => {
        if (constants && session) {
            const currentCountry = constants.countries.find(
                (country) => country.code === session.country
            );
            if (currentCountry) setCountry(currentCountry.name);
        }
    }, []);

    return country;
};
